/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BatchTransferResponse,
  ClaimAcceptanceAcceptRequest,
  GetUnitProcessByIdResponse,
  OperationResponse,
  ProcessExportRequest,
  QueryUnitProcessResponse,
  UnitProcessControllerAcceptanceRejectParams,
  UnitProcessControllerBatchTransferBodyItem,
  UnitProcessControllerCancelParams,
  UnitProcessControllerClaimAcceptanceAcceptParams,
  UnitProcessControllerClaimBody,
  UnitProcessControllerClaimParams,
  UnitProcessControllerExportProcessesParams,
  UnitProcessControllerGetUnitProcessesParams,
  UnitProcessControllerIssueBody,
  UnitProcessControllerIssueNewTreeBody,
  UnitProcessControllerSignaturesRejectParams,
  UnitProcessControllerSignaturesSignParams,
  UnitProcessControllerSplitBody,
  UnitProcessControllerTransferAcceptanceAcceptParams,
  UnitProcessControllerTransferBody
} from './sAFcBackend.schemas.js';

import unitProcessControllerGetUnitProcessesMutator from '../response-type.js';
import unitProcessControllerGetUnitProcessByIdMutator from '../response-type.js';
import unitProcessControllerExportProcessesMutator from '../response-type.js';
import unitProcessControllerIssueMutator from '../response-type.js';
import unitProcessControllerSplitMutator from '../response-type.js';
import unitProcessControllerIssueNewTreeMutator from '../response-type.js';
import unitProcessControllerTransferMutator from '../response-type.js';
import unitProcessControllerBatchTransferMutator from '../response-type.js';
import unitProcessControllerClaimMutator from '../response-type.js';
import unitProcessControllerTransferAcceptanceAcceptMutator from '../response-type.js';
import unitProcessControllerClaimAcceptanceAcceptMutator from '../response-type.js';
import unitProcessControllerAcceptanceRejectMutator from '../response-type.js';
import unitProcessControllerSignaturesSignMutator from '../response-type.js';
import unitProcessControllerSignaturesRejectMutator from '../response-type.js';
import unitProcessControllerCancelMutator from '../response-type.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const unitProcessControllerGetUnitProcesses = (
    params: UnitProcessControllerGetUnitProcessesParams,
 options?: SecondParameter<typeof unitProcessControllerGetUnitProcessesMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerGetUnitProcessesMutator<QueryUnitProcessResponse>(
      {url: `/api/unit-process/query`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUnitProcessControllerGetUnitProcessesQueryKey = (params?: UnitProcessControllerGetUnitProcessesParams,) => {
    return [
    `/api/unit-process/query`, ...(params ? [params] : [])
    ] as const;
    }


export const getUnitProcessControllerGetUnitProcessesQueryOptions = <TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError = unknown>(params: UnitProcessControllerGetUnitProcessesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError, TData>>, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessesMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnitProcessControllerGetUnitProcessesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>> = ({ signal }) => unitProcessControllerGetUnitProcesses(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UnitProcessControllerGetUnitProcessesQueryResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>>
export type UnitProcessControllerGetUnitProcessesQueryError = unknown


export function useUnitProcessControllerGetUnitProcesses<TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError = unknown>(
 params: UnitProcessControllerGetUnitProcessesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>,
          TError,
          Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessesMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnitProcessControllerGetUnitProcesses<TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError = unknown>(
 params: UnitProcessControllerGetUnitProcessesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>,
          TError,
          Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessesMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnitProcessControllerGetUnitProcesses<TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError = unknown>(
 params: UnitProcessControllerGetUnitProcessesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError, TData>>, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessesMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUnitProcessControllerGetUnitProcesses<TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError = unknown>(
 params: UnitProcessControllerGetUnitProcessesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcesses>>, TError, TData>>, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessesMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUnitProcessControllerGetUnitProcessesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const unitProcessControllerGetUnitProcessById = (
    id: string,
 options?: SecondParameter<typeof unitProcessControllerGetUnitProcessByIdMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerGetUnitProcessByIdMutator<GetUnitProcessByIdResponse>(
      {url: `/api/unit-process/${id}`, method: 'GET', signal
    },
      options);
    }




export const getUnitProcessControllerGetUnitProcessByIdQueryKey = (id: string,) => {
    return [
    `/api/unit-process/${id}`
    ] as const;
    }


export const getUnitProcessControllerGetUnitProcessByIdQueryOptions = <TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError, TData>>, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessByIdMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUnitProcessControllerGetUnitProcessByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>> = ({ signal }) => unitProcessControllerGetUnitProcessById(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UnitProcessControllerGetUnitProcessByIdQueryResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>>
export type UnitProcessControllerGetUnitProcessByIdQueryError = unknown


export function useUnitProcessControllerGetUnitProcessById<TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>,
          TError,
          Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessByIdMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnitProcessControllerGetUnitProcessById<TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>,
          TError,
          Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessByIdMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUnitProcessControllerGetUnitProcessById<TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError, TData>>, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessByIdMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUnitProcessControllerGetUnitProcessById<TData = Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof unitProcessControllerGetUnitProcessById>>, TError, TData>>, request?: SecondParameter<typeof unitProcessControllerGetUnitProcessByIdMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUnitProcessControllerGetUnitProcessByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Export unit processes
 */
export const unitProcessControllerExportProcesses = (
    processExportRequest: ProcessExportRequest,
    params: UnitProcessControllerExportProcessesParams,
 options?: SecondParameter<typeof unitProcessControllerExportProcessesMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerExportProcessesMutator<Blob>(
      {url: `/api/unit-process/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processExportRequest,
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getUnitProcessControllerExportProcessesMutationKey = () => ['unitProcessControllerExportProcesses'] as const;

export const getUnitProcessControllerExportProcessesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerExportProcesses>>, TError,UnitProcessControllerExportProcessesMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerExportProcessesMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerExportProcesses>>, TError,UnitProcessControllerExportProcessesMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerExportProcessesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerExportProcesses>>, UnitProcessControllerExportProcessesMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  unitProcessControllerExportProcesses(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerExportProcessesMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerExportProcesses>>>
    export type UnitProcessControllerExportProcessesMutationBody = ProcessExportRequest
    export type UnitProcessControllerExportProcessesMutationError = unknown
    export type UnitProcessControllerExportProcessesMutationVariables = {data: ProcessExportRequest;params: UnitProcessControllerExportProcessesParams}

    export const useUnitProcessControllerExportProcesses = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerExportProcesses>>, TError,UnitProcessControllerExportProcessesMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerExportProcessesMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerExportProcesses>>,
        TError,
        UnitProcessControllerExportProcessesMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerExportProcessesMutationOptions(options), queryClient);
    }
    /**
 * Initiate issue process
 */
export const unitProcessControllerIssue = (
    unitProcessControllerIssueBody: UnitProcessControllerIssueBody,
 options?: SecondParameter<typeof unitProcessControllerIssueMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerIssueMutator<OperationResponse>(
      {url: `/api/unit-process/issue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unitProcessControllerIssueBody, signal
    },
      options);
    }




export const getUnitProcessControllerIssueMutationKey = () => ['unitProcessControllerIssue'] as const;

export const getUnitProcessControllerIssueMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerIssue>>, TError,UnitProcessControllerIssueMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerIssueMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerIssue>>, TError,UnitProcessControllerIssueMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerIssueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerIssue>>, UnitProcessControllerIssueMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unitProcessControllerIssue(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerIssueMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerIssue>>>
    export type UnitProcessControllerIssueMutationBody = UnitProcessControllerIssueBody
    export type UnitProcessControllerIssueMutationError = unknown
    export type UnitProcessControllerIssueMutationVariables = {data: UnitProcessControllerIssueBody}

    export const useUnitProcessControllerIssue = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerIssue>>, TError,UnitProcessControllerIssueMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerIssueMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerIssue>>,
        TError,
        UnitProcessControllerIssueMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerIssueMutationOptions(options), queryClient);
    }
    /**
 * Initiate split process
 */
export const unitProcessControllerSplit = (
    unitProcessControllerSplitBody: UnitProcessControllerSplitBody,
 options?: SecondParameter<typeof unitProcessControllerSplitMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerSplitMutator<OperationResponse>(
      {url: `/api/unit-process/split`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unitProcessControllerSplitBody, signal
    },
      options);
    }




export const getUnitProcessControllerSplitMutationKey = () => ['unitProcessControllerSplit'] as const;

export const getUnitProcessControllerSplitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSplit>>, TError,UnitProcessControllerSplitMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerSplitMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSplit>>, TError,UnitProcessControllerSplitMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerSplitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerSplit>>, UnitProcessControllerSplitMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unitProcessControllerSplit(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerSplitMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerSplit>>>
    export type UnitProcessControllerSplitMutationBody = UnitProcessControllerSplitBody
    export type UnitProcessControllerSplitMutationError = unknown
    export type UnitProcessControllerSplitMutationVariables = {data: UnitProcessControllerSplitBody}

    export const useUnitProcessControllerSplit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSplit>>, TError,UnitProcessControllerSplitMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerSplitMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerSplit>>,
        TError,
        UnitProcessControllerSplitMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerSplitMutationOptions(options), queryClient);
    }
    /**
 * Initiate issue new tree process
 */
export const unitProcessControllerIssueNewTree = (
    unitProcessControllerIssueNewTreeBody: UnitProcessControllerIssueNewTreeBody,
 options?: SecondParameter<typeof unitProcessControllerIssueNewTreeMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerIssueNewTreeMutator<OperationResponse>(
      {url: `/api/unit-process/issue-new-tree`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unitProcessControllerIssueNewTreeBody, signal
    },
      options);
    }




export const getUnitProcessControllerIssueNewTreeMutationKey = () => ['unitProcessControllerIssueNewTree'] as const;

export const getUnitProcessControllerIssueNewTreeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerIssueNewTree>>, TError,UnitProcessControllerIssueNewTreeMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerIssueNewTreeMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerIssueNewTree>>, TError,UnitProcessControllerIssueNewTreeMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerIssueNewTreeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerIssueNewTree>>, UnitProcessControllerIssueNewTreeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unitProcessControllerIssueNewTree(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerIssueNewTreeMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerIssueNewTree>>>
    export type UnitProcessControllerIssueNewTreeMutationBody = UnitProcessControllerIssueNewTreeBody
    export type UnitProcessControllerIssueNewTreeMutationError = unknown
    export type UnitProcessControllerIssueNewTreeMutationVariables = {data: UnitProcessControllerIssueNewTreeBody}

    export const useUnitProcessControllerIssueNewTree = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerIssueNewTree>>, TError,UnitProcessControllerIssueNewTreeMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerIssueNewTreeMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerIssueNewTree>>,
        TError,
        UnitProcessControllerIssueNewTreeMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerIssueNewTreeMutationOptions(options), queryClient);
    }
    /**
 * Initiate transfer process
 */
export const unitProcessControllerTransfer = (
    unitProcessControllerTransferBody: UnitProcessControllerTransferBody,
 options?: SecondParameter<typeof unitProcessControllerTransferMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerTransferMutator<OperationResponse>(
      {url: `/api/unit-process/transfer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unitProcessControllerTransferBody, signal
    },
      options);
    }




export const getUnitProcessControllerTransferMutationKey = () => ['unitProcessControllerTransfer'] as const;

export const getUnitProcessControllerTransferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerTransfer>>, TError,UnitProcessControllerTransferMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerTransferMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerTransfer>>, TError,UnitProcessControllerTransferMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerTransferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerTransfer>>, UnitProcessControllerTransferMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unitProcessControllerTransfer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerTransferMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerTransfer>>>
    export type UnitProcessControllerTransferMutationBody = UnitProcessControllerTransferBody
    export type UnitProcessControllerTransferMutationError = unknown
    export type UnitProcessControllerTransferMutationVariables = {data: UnitProcessControllerTransferBody}

    export const useUnitProcessControllerTransfer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerTransfer>>, TError,UnitProcessControllerTransferMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerTransferMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerTransfer>>,
        TError,
        UnitProcessControllerTransferMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerTransferMutationOptions(options), queryClient);
    }
    /**
 * Initiate batch transfer process
 */
export const unitProcessControllerBatchTransfer = (
    unitProcessControllerBatchTransferBodyItem: UnitProcessControllerBatchTransferBodyItem[],
 options?: SecondParameter<typeof unitProcessControllerBatchTransferMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerBatchTransferMutator<BatchTransferResponse>(
      {url: `/api/unit-process/transfer/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unitProcessControllerBatchTransferBodyItem, signal
    },
      options);
    }




export const getUnitProcessControllerBatchTransferMutationKey = () => ['unitProcessControllerBatchTransfer'] as const;

export const getUnitProcessControllerBatchTransferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerBatchTransfer>>, TError,UnitProcessControllerBatchTransferMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerBatchTransferMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerBatchTransfer>>, TError,UnitProcessControllerBatchTransferMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerBatchTransferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerBatchTransfer>>, UnitProcessControllerBatchTransferMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  unitProcessControllerBatchTransfer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerBatchTransferMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerBatchTransfer>>>
    export type UnitProcessControllerBatchTransferMutationBody = UnitProcessControllerBatchTransferBodyItem[]
    export type UnitProcessControllerBatchTransferMutationError = unknown
    export type UnitProcessControllerBatchTransferMutationVariables = {data: UnitProcessControllerBatchTransferBodyItem[]}

    export const useUnitProcessControllerBatchTransfer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerBatchTransfer>>, TError,UnitProcessControllerBatchTransferMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerBatchTransferMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerBatchTransfer>>,
        TError,
        UnitProcessControllerBatchTransferMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerBatchTransferMutationOptions(options), queryClient);
    }
    /**
 * Initiate claim process
 */
export const unitProcessControllerClaim = (
    unitProcessControllerClaimBody: UnitProcessControllerClaimBody,
    params: UnitProcessControllerClaimParams,
 options?: SecondParameter<typeof unitProcessControllerClaimMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerClaimMutator<OperationResponse>(
      {url: `/api/unit-process/claim`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unitProcessControllerClaimBody,
        params, signal
    },
      options);
    }




export const getUnitProcessControllerClaimMutationKey = () => ['unitProcessControllerClaim'] as const;

export const getUnitProcessControllerClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerClaim>>, TError,UnitProcessControllerClaimMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerClaimMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerClaim>>, TError,UnitProcessControllerClaimMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerClaimMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerClaim>>, UnitProcessControllerClaimMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  unitProcessControllerClaim(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerClaimMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerClaim>>>
    export type UnitProcessControllerClaimMutationBody = UnitProcessControllerClaimBody
    export type UnitProcessControllerClaimMutationError = unknown
    export type UnitProcessControllerClaimMutationVariables = {data: UnitProcessControllerClaimBody;params: UnitProcessControllerClaimParams}

    export const useUnitProcessControllerClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerClaim>>, TError,UnitProcessControllerClaimMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerClaimMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerClaim>>,
        TError,
        UnitProcessControllerClaimMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerClaimMutationOptions(options), queryClient);
    }
    /**
 * Accept transfer by process id
 */
export const unitProcessControllerTransferAcceptanceAccept = (
    id: string,
    params: UnitProcessControllerTransferAcceptanceAcceptParams,
 options?: SecondParameter<typeof unitProcessControllerTransferAcceptanceAcceptMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerTransferAcceptanceAcceptMutator<void>(
      {url: `/api/unit-process/${id}/transfer-acceptance-accept`, method: 'POST',
        params, signal
    },
      options);
    }




export const getUnitProcessControllerTransferAcceptanceAcceptMutationKey = () => ['unitProcessControllerTransferAcceptanceAccept'] as const;

export const getUnitProcessControllerTransferAcceptanceAcceptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerTransferAcceptanceAccept>>, TError,UnitProcessControllerTransferAcceptanceAcceptMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerTransferAcceptanceAcceptMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerTransferAcceptanceAccept>>, TError,UnitProcessControllerTransferAcceptanceAcceptMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerTransferAcceptanceAcceptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerTransferAcceptanceAccept>>, UnitProcessControllerTransferAcceptanceAcceptMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  unitProcessControllerTransferAcceptanceAccept(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerTransferAcceptanceAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerTransferAcceptanceAccept>>>

    export type UnitProcessControllerTransferAcceptanceAcceptMutationError = unknown
    export type UnitProcessControllerTransferAcceptanceAcceptMutationVariables = {id: string;params: UnitProcessControllerTransferAcceptanceAcceptParams}

    export const useUnitProcessControllerTransferAcceptanceAccept = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerTransferAcceptanceAccept>>, TError,UnitProcessControllerTransferAcceptanceAcceptMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerTransferAcceptanceAcceptMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerTransferAcceptanceAccept>>,
        TError,
        UnitProcessControllerTransferAcceptanceAcceptMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerTransferAcceptanceAcceptMutationOptions(options), queryClient);
    }
    /**
 * Accept claim by process id
 */
export const unitProcessControllerClaimAcceptanceAccept = (
    id: string,
    claimAcceptanceAcceptRequest: ClaimAcceptanceAcceptRequest,
    params: UnitProcessControllerClaimAcceptanceAcceptParams,
 options?: SecondParameter<typeof unitProcessControllerClaimAcceptanceAcceptMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerClaimAcceptanceAcceptMutator<void>(
      {url: `/api/unit-process/${id}/claim-acceptance-accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: claimAcceptanceAcceptRequest,
        params, signal
    },
      options);
    }




export const getUnitProcessControllerClaimAcceptanceAcceptMutationKey = () => ['unitProcessControllerClaimAcceptanceAccept'] as const;

export const getUnitProcessControllerClaimAcceptanceAcceptMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerClaimAcceptanceAccept>>, TError,UnitProcessControllerClaimAcceptanceAcceptMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerClaimAcceptanceAcceptMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerClaimAcceptanceAccept>>, TError,UnitProcessControllerClaimAcceptanceAcceptMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerClaimAcceptanceAcceptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerClaimAcceptanceAccept>>, UnitProcessControllerClaimAcceptanceAcceptMutationVariables> = (props) => {
          const {id,data,params} = props ?? {};

          return  unitProcessControllerClaimAcceptanceAccept(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerClaimAcceptanceAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerClaimAcceptanceAccept>>>
    export type UnitProcessControllerClaimAcceptanceAcceptMutationBody = ClaimAcceptanceAcceptRequest
    export type UnitProcessControllerClaimAcceptanceAcceptMutationError = unknown
    export type UnitProcessControllerClaimAcceptanceAcceptMutationVariables = {id: string;data: ClaimAcceptanceAcceptRequest;params: UnitProcessControllerClaimAcceptanceAcceptParams}

    export const useUnitProcessControllerClaimAcceptanceAccept = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerClaimAcceptanceAccept>>, TError,UnitProcessControllerClaimAcceptanceAcceptMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerClaimAcceptanceAcceptMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerClaimAcceptanceAccept>>,
        TError,
        UnitProcessControllerClaimAcceptanceAcceptMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerClaimAcceptanceAcceptMutationOptions(options), queryClient);
    }
    /**
 * Reject claim or transfer by process id
 */
export const unitProcessControllerAcceptanceReject = (
    id: string,
    params: UnitProcessControllerAcceptanceRejectParams,
 options?: SecondParameter<typeof unitProcessControllerAcceptanceRejectMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerAcceptanceRejectMutator<void>(
      {url: `/api/unit-process/${id}/acceptance-reject`, method: 'POST',
        params, signal
    },
      options);
    }




export const getUnitProcessControllerAcceptanceRejectMutationKey = () => ['unitProcessControllerAcceptanceReject'] as const;

export const getUnitProcessControllerAcceptanceRejectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerAcceptanceReject>>, TError,UnitProcessControllerAcceptanceRejectMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerAcceptanceRejectMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerAcceptanceReject>>, TError,UnitProcessControllerAcceptanceRejectMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerAcceptanceRejectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerAcceptanceReject>>, UnitProcessControllerAcceptanceRejectMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  unitProcessControllerAcceptanceReject(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerAcceptanceRejectMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerAcceptanceReject>>>

    export type UnitProcessControllerAcceptanceRejectMutationError = unknown
    export type UnitProcessControllerAcceptanceRejectMutationVariables = {id: string;params: UnitProcessControllerAcceptanceRejectParams}

    export const useUnitProcessControllerAcceptanceReject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerAcceptanceReject>>, TError,UnitProcessControllerAcceptanceRejectMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerAcceptanceRejectMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerAcceptanceReject>>,
        TError,
        UnitProcessControllerAcceptanceRejectMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerAcceptanceRejectMutationOptions(options), queryClient);
    }
    /**
 * Sign process by process id
 */
export const unitProcessControllerSignaturesSign = (
    id: string,
    params: UnitProcessControllerSignaturesSignParams,
 options?: SecondParameter<typeof unitProcessControllerSignaturesSignMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerSignaturesSignMutator<void>(
      {url: `/api/unit-process/${id}/signatures-sign`, method: 'POST',
        params, signal
    },
      options);
    }




export const getUnitProcessControllerSignaturesSignMutationKey = () => ['unitProcessControllerSignaturesSign'] as const;

export const getUnitProcessControllerSignaturesSignMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSignaturesSign>>, TError,UnitProcessControllerSignaturesSignMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerSignaturesSignMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSignaturesSign>>, TError,UnitProcessControllerSignaturesSignMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerSignaturesSignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerSignaturesSign>>, UnitProcessControllerSignaturesSignMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  unitProcessControllerSignaturesSign(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerSignaturesSignMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerSignaturesSign>>>

    export type UnitProcessControllerSignaturesSignMutationError = unknown
    export type UnitProcessControllerSignaturesSignMutationVariables = {id: string;params: UnitProcessControllerSignaturesSignParams}

    export const useUnitProcessControllerSignaturesSign = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSignaturesSign>>, TError,UnitProcessControllerSignaturesSignMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerSignaturesSignMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerSignaturesSign>>,
        TError,
        UnitProcessControllerSignaturesSignMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerSignaturesSignMutationOptions(options), queryClient);
    }
    /**
 * Reject signature by process id
 */
export const unitProcessControllerSignaturesReject = (
    id: string,
    params: UnitProcessControllerSignaturesRejectParams,
 options?: SecondParameter<typeof unitProcessControllerSignaturesRejectMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerSignaturesRejectMutator<void>(
      {url: `/api/unit-process/${id}/signatures-reject`, method: 'POST',
        params, signal
    },
      options);
    }




export const getUnitProcessControllerSignaturesRejectMutationKey = () => ['unitProcessControllerSignaturesReject'] as const;

export const getUnitProcessControllerSignaturesRejectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSignaturesReject>>, TError,UnitProcessControllerSignaturesRejectMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerSignaturesRejectMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSignaturesReject>>, TError,UnitProcessControllerSignaturesRejectMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerSignaturesRejectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerSignaturesReject>>, UnitProcessControllerSignaturesRejectMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  unitProcessControllerSignaturesReject(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerSignaturesRejectMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerSignaturesReject>>>

    export type UnitProcessControllerSignaturesRejectMutationError = unknown
    export type UnitProcessControllerSignaturesRejectMutationVariables = {id: string;params: UnitProcessControllerSignaturesRejectParams}

    export const useUnitProcessControllerSignaturesReject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerSignaturesReject>>, TError,UnitProcessControllerSignaturesRejectMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerSignaturesRejectMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerSignaturesReject>>,
        TError,
        UnitProcessControllerSignaturesRejectMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerSignaturesRejectMutationOptions(options), queryClient);
    }
    /**
 * Cancel process by process id
 */
export const unitProcessControllerCancel = (
    id: string,
    params: UnitProcessControllerCancelParams,
 options?: SecondParameter<typeof unitProcessControllerCancelMutator>,signal?: AbortSignal
) => {


      return unitProcessControllerCancelMutator<void>(
      {url: `/api/unit-process/${id}/cancel`, method: 'POST',
        params, signal
    },
      options);
    }




export const getUnitProcessControllerCancelMutationKey = () => ['unitProcessControllerCancel'] as const;

export const getUnitProcessControllerCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerCancel>>, TError,UnitProcessControllerCancelMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerCancelMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerCancel>>, TError,UnitProcessControllerCancelMutationVariables, TContext> => {

const mutationKey = getUnitProcessControllerCancelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unitProcessControllerCancel>>, UnitProcessControllerCancelMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  unitProcessControllerCancel(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnitProcessControllerCancelMutationResult = NonNullable<Awaited<ReturnType<typeof unitProcessControllerCancel>>>

    export type UnitProcessControllerCancelMutationError = unknown
    export type UnitProcessControllerCancelMutationVariables = {id: string;params: UnitProcessControllerCancelParams}

    export const useUnitProcessControllerCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unitProcessControllerCancel>>, TError,UnitProcessControllerCancelMutationVariables, TContext>, request?: SecondParameter<typeof unitProcessControllerCancelMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unitProcessControllerCancel>>,
        TError,
        UnitProcessControllerCancelMutationVariables,
        TContext
      > => {
      return useMutation(getUnitProcessControllerCancelMutationOptions(options), queryClient);
    }
